import { render, staticRenderFns } from "./ProductOrder.vue?vue&type=template&id=0fd181ce&"
import script from "./ProductOrder.vue?vue&type=script&lang=js&"
export * from "./ProductOrder.vue?vue&type=script&lang=js&"
import style0 from "./ProductOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports